import { ActionsAdAssistant } from "./ActionsAdAssistant";
import { callWebUtils } from "../../Components/CampaignMembers/helpers";

export const ActionsListenersAdAssistant = ({ database }) => {
  ActionsAdAssistant.getCloudinaryImagesByCompanyId.listen(function (companyId) {
    return callWebUtils(this, "getCloudinaryImagesByCompanyId", [companyId]);
  });

  ActionsAdAssistant.getOldUploadedImages.listen(function (
    orgaName,
    companyName,
    orgaId,
    campaignId = null
  ) {
    return callWebUtils(this, "getUploadedImages", [{ orgaName, companyName, orgaId, campaignId }]);
  });

  ActionsAdAssistant.generateThreadId.listen(function (data) {
    return callWebUtils(this, "generateThreadId", [data]);
  });

  ActionsAdAssistant.generateAssistantMessage.listen(function (data) {
    return callWebUtils(this, "generateAssistantMessage", [data]);
  });

  ActionsAdAssistant.createAssistantCampaign.listen(function (data) {
    return callWebUtils(this, "createAssistantCampaign", [data]);
  });

  ActionsAdAssistant.updateAssistantCampaign.listen(function (data, campaignId) {
    return callWebUtils(this, "updateAssistantCampaign", [data, campaignId]);
  });

  ActionsAdAssistant.getAssistantCampaign.listen(function (campaignId) {
    return callWebUtils(this, "getAssistantCampaign", [campaignId]);
  });

  ActionsAdAssistant.getAdCombinations.listen(function (campaignId) {
    return callWebUtils(this, "getAdCombinations", [campaignId]);
  });

  ActionsAdAssistant.getJobTitlesByCategoryId.listen(function (jobCategoryId) {
    return database.loadJobCategory(jobCategoryId).then(this.completed).catch(this.failed);
  });

  ActionsAdAssistant.createAd.listen(function (data) {
    return callWebUtils(this, "createAd", [data]);
  });

  ActionsAdAssistant.updateAd.listen(function (data, adId) {
    return callWebUtils(this, "updateAd", [data, adId]);
  });

  ActionsAdAssistant.getAdVersions.listen(function (adId, { offset, limit } = {}) {
    return callWebUtils(this, "getAdVersions", [adId, { offset, limit }]);
  });

  ActionsAdAssistant.setActiveAdVersion.listen(function (adId, versionId) {
    return callWebUtils(this, "setActiveAdVersion", [adId, versionId]);
  });

  ActionsAdAssistant.setAdAssistantCampaignLive.listen(function (data, campaignId) {
    return callWebUtils(this, "setAdAssistantCampaignLive", [data, campaignId]);
  });

  ActionsAdAssistant.getAssistantKeywordsByJobTitle.listen(function (jobTitle) {
    return callWebUtils(this, "getAssistantKeywordsByJobTitle", [jobTitle]);
  });

  ActionsAdAssistant.getAllCompanies.listen(function (organizationId) {
    return callWebUtils(this, "getAllCompanies", [organizationId]);
  });
};
